import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectFilters = state => state.get('filters', initialState);

const makeSelectTags = () =>
  createSelector(selectFilters, selectedState =>
    selectedState.get('tags').toArray(),
  );

const makeSelectFiltersOption = () =>
  createSelector(selectFilters, selectedState =>
    selectedState.get('selectedTags').toArray(),
  );

const makeSelectSelectedTags = () =>
  createSelector(selectFilters, selectedState =>
    selectedState.get('selectedTags').toArray(),
  );

const makeSelectSort = () =>
  createSelector(selectFilters, selectedState =>
    selectedState.get('sorts').toArray(),
  );

const makeSelectSelectedSort = () =>
  createSelector(selectFilters, selectedState =>
    selectedState.get('selectedSort'),
  );

const makeSelectTagsEnabled = () =>
  createSelector(selectFilters, selectedState =>
    selectedState.get('isTagsEnabled'),
  );

const transformSelectedFiltersForQuesystring = selectedFilters => {
  let obj = {};

  selectedFilters.forEach(filter => {
    const filterKey = filter.name || filter.value;
    const filterValue = filter.name ? filter.value : 1;

    obj[filterKey] = filterValue
  })

  return obj;
}

export {
  selectFilters,
  makeSelectTags,
  makeSelectSelectedTags,
  makeSelectFiltersOption,
  makeSelectSort,
  makeSelectSelectedSort,
  makeSelectTagsEnabled,
  transformSelectedFiltersForQuesystring,
};
